import React, { useState } from 'react';
import {
  Button,
  TopToolbar,
  useListContext,
  FilterButton,
  ExportButton,
} from 'react-admin';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import UploadModal from './UploadModal.component';
import logger from '../../utils/logger';
const ListActions = () => {
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const { total, refetch } = useListContext();

  const handleUploadSuccess = async () => {
    logger.log('handleUploadSuccess called - fetching fresh data from server');

    if (refetch) {
      try {
        // Force a complete refresh with no cache
        logger.log('Calling refetch to get fresh data');
        await refetch();

        // Get the list controller and manually update pagination if needed
        logger.log('Data refreshed successfully');
      } catch (error) {
        logger.error('Error refreshing data:', error);

        // Try again after a short delay if it failed
        setTimeout(async () => {
          try {
            logger.log('Retrying refresh after error');
            await refetch();
          } catch (retryError) {
            logger.error('Retry refresh failed:', retryError);
          }
        }, 1000);
      }
    }
  };

  return (
    <TopToolbar>
      <FilterButton />
      <Button
        onClick={() => setUploadModalOpen(true)}
        label="Upload New List"
        startIcon={<UploadFileIcon />}
        variant="contained"
      />
      {/* <ExportButton disabled={total === 0} maxResults={10000} /> */}
      {/* Confirmed with Product team: Export is not needed for lead imports jobs, only for the lead list page */}
      <UploadModal
        open={uploadModalOpen}
        onClose={() => setUploadModalOpen(false)}
        onSuccess={handleUploadSuccess}
      />
    </TopToolbar>
  );
};

export default ListActions;
